export enum TemplateType {
    SURVEY = 'survey',
    REVIEW = 'review',
}
